import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Accordion from 'reusableComponents/Accordion'
import { breakpoints, colors } from 'globalStyles'
import TransitHistory from 'components/TransitHistory'
import ShipmentDetails from 'components/ShipmentDetails'

const StyledDiv = styled.div`
  text-align: left;
  color: ${colors.secondary_grey};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

const StyledAccordion = styled(Accordion)`
  @media ${breakpoints.phone} {
    width: 328px;
  }
  @media ${breakpoints.tablet} {
    width: 612px;
  }
`
const StyledHeading = styled.div`
  font-weight: 600;
  color: ${colors.text_link};
  font-size: 14px;
`
const StyledInfoHeading = styled.div`
  text-align: center;
  color: ${colors.secondary_grey};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  @media only screen and ${breakpoints.tablet} {
    font-weight: 400;
  }
`

const AdditionalInformation = ({ device }) => {
  const { t } = useTranslation()
  // Use for mobile and tablet
  const accordionItems = [
    {
      heading: <StyledHeading>{t('additional_info.view_transit_history')}</StyledHeading>,
      body: <TransitHistory />,
    },
    {
      heading: <StyledHeading>{t('additional_info.view_shipment_details')}</StyledHeading>,
      body: <ShipmentDetails />,
    },
  ]
  return device === 'desktop' ? (
    <>
      <StyledDiv>{t('additional_info.heading')}</StyledDiv>
      <div style={{ display: 'flex', gap: '24px' }}>
        <TransitHistory />
        <ShipmentDetails />
      </div>
    </>
  ) : (
    <>
      <StyledInfoHeading>{t('additional_info.heading')}</StyledInfoHeading>
      <StyledAccordion defaultActiveKey="0" items={accordionItems} />
    </>
  )
}

AdditionalInformation.propTypes = {
  device: PropTypes.string.isRequired,
}

AdditionalInformation.defaultProps = {}

export default AdditionalInformation
